import {COMMUNITY} from '../../../endpoints'
import {apiPublic} from '../../../api'
import types from '../types/item'
import {endpoint as endpointText} from '../../../common/text'

export default class item {

  static fetch(id) {
    return function(dispatch) {

      dispatch({type: types.FETCH})

      apiPublic.get(COMMUNITY + '/community/object/' + id)
        .then(response => {
          dispatch(item.fetchSuccess(response.data.description))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(item.fetchFail(message))
        })
    }
  }

  static fetchSuccess(data) {
    return {
      type: types.FETCH_SUCCESS,
      payload: {
        item: data,
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/items/actions/item.js